export enum ExceptionType {
    BAD_CREDENTIALS = 'org.springframework.security.authentication.BadCredentialsException',
    INVALID_TOTP_CODE = 'com.itfgroup.auth.mfa.InvalidTotpCodeException',
}